<div class="logo"></div>
<div class="main-panel" [ngSwitch]="state">
  <div class="success-panel" *ngSwitchCase="JustDoneWidgetState.Success">
    <label>{{ doneText }}</label>
  </div>
  <div class="fail-panel" *ngSwitchCase="JustDoneWidgetState.Fail">
    <label class="header">Error</label>
    <label class="error-text">{{ errorCode | translateCode }}</label>
  </div>
</div>
<div class="empty-bottom-part"></div>
